(function () {
    'use strict';

    angular.module("imApp").factory("projectInvoicingsService", ['$ihttp', function ($ihttp) {
        let service = {
            getProjectInvoicings: function (parms) {
                return $ihttp.post({
                    method: 2196,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
